import type { Stripe } from 'stripe';

export function addressOfSession(session: Stripe.Checkout.Session) {
	const address = session.customer_details?.address || {};

	return Object.keys(address).reduce(
		(prev, curr) => ({ ...prev, [curr]: address[curr as keyof typeof address] ?? '' }),
		{} as Stripe.Address
	);
}
